import { ThemeColors } from "@insite/mobius/globals/baseTheme";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { css } from "styled-components";

export const fontFamilyHeader = "'Saira', sans-serif";
export const fontFamily = "'Nunito', sans-serif";

export const mediaQueriesBP = {
    maxSM: "@media screen and (max-width: 424px)",
    minSM: "@media screen and (min-width: 425px)",

    maxMD: "@media screen and (max-width: 767px)",
    minMD: "@media screen and (min-width: 768px)",

    maxLG: "@media screen and (max-width: 1023px)",
    minLG: "@media screen and (min-width: 1024px)",

    maxXLG: "@media screen and (max-width: 1199px)",
    minXLG: "@media screen and (min-width: 1200px)",

    minMDMaxLg: "@media screen and (min-width: 768px) and (max-width: 1023px)",
};

export const calcInitial = "calc(((100vw - 100%) / 2) * -1)";

export const colorPalette: RecursivePartial<ThemeColors> = {
    primary: {
        main: "#8a1538",
    },
    secondary: {
        main: "#4b4c51",
    },
    success: {
        main: "#008768",
    },
    danger: {
        main: "#de3502",
    },
    warning: {
        main: "#ffcc00",
    },
    text: {
        main: "#222",
        link: "#03045E",
    },
    common: {
        primaryAlt: {
            main: "#fff",
            contrast: "#8a1538",
        },
        background: "#fff",
        border: "#999999",
        disabled: "#d3d3d3",
        global: {
            white: "#fff",
            black: "#000",
            // Primary
            // Secondary
            // Grays
            gray01: "#222",
            gray02: "#444",
            gray03: "#d3d3d3",
            gray04: "#f6f6f6",
            gray05: "#e5e5e5",

            // UI
            uiGreen: "#008768",
            uiRed: "#de3502",
            uiYellow: "#ffcc00",

            // Header
            headerBg: "#03045e",

            // Client specific colors
        },
    } as any,
};

export const colorStrings = {
    primaryMain: "primary.main",
    secondaryMain: "secondary.main",
    successMain: "success.main",
    dangerMain: "danger.main",
    warningMain: "warning.main",
    infoMain: "info.main",
    commonBackground: "common.background",
    commonBorder: "common.border",
    textMain: "text.main",
    textLink: "text.link",
    common: "common",
    commonDisabled: "common.disabled",

    commonPrimaryAlt: "common.primaryAlt",
    commonGlobalWhite: "common.global.white",
    commonGlobalBlack: "common.global.black",
    commonGlobalGray01: "common.global.gray01",
    commonGlobalGray02: "common.global.gray02",
    commonGlobalGray03: "common.global.gray03",
    commonGlobalGray04: "common.global.gray04",
    commonGlobalGray05: "common.global.gray05",
    commonGlobalHeaderBg: "common.global.headerBg",
};

export const manualStyles = {
    // TODO: Create opti ticket for adjusting current URL regex validation
    headerMobileSelected: css`
        background: ${getColor(colorStrings.secondaryMain)}33;
        color: ${getColor(colorStrings.textMain)};
    `,
};
